import AttachmentsDetails from './attachments-details'
import EnvelopeStatus from '@/components/_modules/Programs/Card-envelopes/EnvelopeStatus.vue'
import OpenEnvelope from './OpenEnvelope'

export default {
  'EnvelopeNumber': {
    label: 'Envelope',
    render: OpenEnvelope,
    width: 130
  },

  CardNumber: {
    label: 'Card Number',
    compose: maskedCardNumber,
    width: 120
  },

  'Holder': {
    label: 'Card Holder',
    width: 120
  },

  'Transactions': {
    label: 'Transactions',
    width: 120
  },

  'Amount': {
    label: 'Amount',
    type: 'money',
    f: 'data.Amount',
    width: 130
  },

  'StartDateFormatted': {
    label: 'Start Date',
    width: 120
  },

  'EndDateFormatted': {
    label: 'End Date',
    width: 120
  },

  'EnvelopeStatus': {
    label: 'Status',
    source: 'EnvelopeList',
    render: EnvelopeStatus,
    width: 140
  },

  'WaitingApproval': {
    label: 'Waiting Approval',
    details: 'local',
    detailsCondition: showAttachmentsExpandIcon,
    detailsParamsURL: getAttachmentsDetailsParams,
    detailsComp: AttachmentsDetails,
    width: 120
  },

  'ProgramName': {
    label: 'Program',
    width: 120
  },

  'BusinessUnit': {
    label: 'Business Unit',
    width: 130
  },

  'APFile': {
    label: 'AP File',
    compose: apFileLink,
    width: 120
  },

  'TransactionNo': {
    label: 'Transaction No',
    width: 120
  },

  'AccountId': '_',

  'CreatedDate': '_',

  'CreatedByUserID': '_',

  'CreatedByUser': '_',

  'RejectionReason': '_'
}

function maskedCardNumber(card) {
  if (card && card.data && card.data.CardNumber) {
    return '****' + card.data.CardNumber
  } else {
    return '****'
  }
}

function showAttachmentsExpandIcon(params) {
  return parseInt(params.data.WaitingApproval) > 0
}
function getAttachmentsDetailsParams(params) {
  return `?envelopeId=${params.data.Id}`
}
function apFileLink(p) {
  if (!p.data) return ''

  const apFileId = p.data.ApFileId

  const url = `${global.app.api.env}/AccountPayable/GenerateEvedPayCardAPFile?apFileId=${apFileId}`

  return `<a title="Open AP File" href="${url}" target="_blank">${p.value}</a>`
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Card-envelopes/model.js